import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';

interface UsersContextData {
  usersCount: number | undefined;
  setUsersCount: Dispatch<SetStateAction<number | undefined>>;
}

export const UsersContext = createContext<UsersContextData | undefined>(
  undefined,
);

const UsersProvider = ({ children }: { children: ReactNode }) => {
  const [usersCount, setUsersCount] = useState<number | undefined>();

  return (
    <UsersContext.Provider
      value={{
        usersCount,
        setUsersCount,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};

export default UsersProvider;
